<h2 mat-dialog-title>{{ isEdit ? 'Edit Brand' : 'Add Brand' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="brand-form" (ngSubmit)="save()">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>{{ 'brandFormDialog.brandName' | transloco }}</mat-label>
      <input matInput formControlName="name" [placeholder]="'brandFormDialog.brandName' | transloco" data-testid="brand-name-input" />
      <mat-error>{{ 'brandFormDialog.brandNameIsRequired' | transloco }}</mat-error>
    </mat-form-field>

    <div class="logo-row">
      <div class="logo-preview" [class.logo-preview-empty]="!previewLogoUrl">
        @if (previewLogoUrl) {
          <img class="brand-logo" [src]="previewLogoUrl" [alt]="'common.labels.logo' | transloco" />
        } @else {
          <mat-icon>image</mat-icon>
        }
      </div>
      <div class="logo-actions">
        <button mat-stroked-button color="primary" type="button" (click)="logoInput.click()">
          <mat-icon>upload</mat-icon> {{ previewLogoUrl ? 'Replace Logo' : 'Upload Logo' }}
        </button>
        @if (uploadedLogoFileName) {
          <span class="logo-filename" [title]="uploadedLogoFileName">{{ uploadedLogoFileName }}</span>
        }
      </div>
      <input #logoInput type="file" accept=".png,.jpg,.jpeg" hidden (change)="onLogoSelected($event)" />
    </div>

    <mat-form-field appearance="outline" class="form-field padding-top-20">
      <mat-label>{{ 'brandFormDialog.brandColourHex' | transloco }}</mat-label>
      @if (swatchPreview) {
        <span matPrefix class="brand-swatch" [style.background-color]="swatchPreview"></span>
      }
      <input matInput formControlName="hexCode" maxlength="7" placeholder="1A2B3C" data-testid="brand-hex-input" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="saving">{{ 'common.buttons.cancel' | transloco }}</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving || form.invalid"
    data-testid="save-brand-button">
    {{ isEdit ? 'Save' : 'Create' }}
  </button>
</mat-dialog-actions>
